import { render, staticRenderFns } from "./DevLayout.vue?vue&type=template&id=6413c1d9&scoped=true&"
import script from "./DevLayout.vue?vue&type=script&lang=js&"
export * from "./DevLayout.vue?vue&type=script&lang=js&"
import style0 from "./DevLayout.vue?vue&type=style&index=0&id=6413c1d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6413c1d9",
  null
  
)

export default component.exports